import React, { useEffect, useState } from "react";
import BookCard from "./BookCard";
import "./Books.css";
import {
  DDG1,
  DDG10,
  DDG2,
  DDG3,
  DDG4,
  DDG5,
  DDG6,
  DDG7,
  DDG8,
  DDG9,
  DG2,
  Digic,
  GV,
  Vow,
} from "../../images/images";
// import Button from "../button/Button"; // "View our Digital Resources" is hidden
import { motion } from "framer-motion";
import { fadeIn, staggerContainer } from "../../utils/motion";
import HorizontalScroller from "../HorizontalScroller/HorizontalScroller";
import HorizontalScroll from "../HorizontalScroll/HorizontalScroll";
import { BOOK_PATH, fetchPublicBooks } from "../../pages/digitalLibrary/bookStoreApi";

const normalize = (title: string) => title.toLowerCase().replace(/[^a-z0-9]/g, "");

const books = [
  {
    image: GV,
    title: "Led By God's Voice",
    desc: "Learn to recognize and discern God's voice with clarity and confidence in everyday life",
    link: "https://www.amazon.com/LED-GODS-VOICE-Recognize-Discern/dp/B0HC7YW6WW/ref=mp_s_a_1_1?crid=33Q1B5USS6809&dib=eyJ2IjoiMSJ9.H8Qpot30AUfK6ta1y2pSqqqP-E4_XiBEHAA9dMLDzKGT71i39610h_R6u8aM4UJiXwXdS9pkKki7iyVz0YgJ5DFdJLENciu0v-efUFRewY5q9madf0t2fUJtU1eFEELNrksiIa2gjCzCm5LUXUnDNVxZkFkzvZqSNQlnZAqw-BAisWyFBshCJMWNQM0guHX6A1jwtKzccluVvSOPxtbmnQ.IdQG4dRh_AIbTxASRt41cDAY9nQIXzu3xkpHFO-V4hc&dib_tag=se&keywords=led+by+god&qid=1787101303&sprefix=%2Caps%2C302&sr=8-1&fbclid=IwY2xjawTyUwxwZG9mBWV4dG4DYWVtAjEwAGJyaWQRMXVkejlKaWtaREVPaERBRFRzcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEetkUQDjKJ27behNv3e6nmsO0fSx8dh_SKepd0iizkmvb3eMibSLoOuCp5A1E_aem_uYs58eu-BWtMLfmqovlVlA",
  },

  {
    image: Vow,
    title: "The Vine and the Vow",
    desc: "Discover how to build a marriage that bears fruit. Build your marriage with God's templates",
  },

  {
    image: DG2,
    title: "The Uncommon Union",
    desc: "Discover how to build a marriage that bears fruit. Build your marriage with God's templates",
  },

  {
    image: Digic,
    title: "The Peace And Love Issue",
    desc: "When to speak and when to stay silent - mastering the art of godly communication in relationships",
  },

  {
    image: DDG2,
    title: "Yes you can change",
    desc: "Finding wisdom in chaotic circumstances",
  },

  {
    image: DDG1,
    title: "Couples doing marriage God's way",
    desc: "Stromng faith, strong love, strong family",
  },

  {
    image: DDG3,
    title: "A call to women of faith and beauty",
    desc: "How modern women are embracing divine assignment over mere ambition",
  },

  {
    image: DDG5,
    title: "Who is like God?",
    desc: "A testament of the mighty hand of  God",
  },

  {
    image: DDG4,
    title: "Spiritual construction manual",
    desc: "Heaven's design for earthly dominion",
  },

  {
    image: DDG6,
    title: "Heaven's Rainbow Promise",
    desc: "Understanding God's covenantal promises in turbulent times",
  },

  {
    image: DDG7,
    title: "A Tiny Seed Called Mustard",
    desc: "Faith that moves mountains",
  },

  // {
  //   image: DDG8,
  //   title: "Who is Like God?",
  //   desc: "A testament of the mighty hand of  God",
  // },

  // {
  //   image: DDG9,
  //   title: "Spiritual construction manual",
  //   desc: "Heaven's design for earthly dominion",
  // },

  {
    image: DDG10,
    title: "Light in My Pocket",
    desc: "Courage, Inner Light, God's Presence",
  },
];

function Books() {
  // Book pages live in the Digital Library admin; match slider titles to them
  const [bookPaths, setBookPaths] = useState<Record<string, string>>({});

  useEffect(() => {
    fetchPublicBooks()
      .then((list) =>
        setBookPaths(Object.fromEntries(list.map((b) => [normalize(b.title), BOOK_PATH(b.id)])))
      )
      .catch(() => setBookPaths({}));
  }, []);

  return (
    <motion.section
      className="books-container"
      variants={staggerContainer(0.2, 0.3)}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
    >
      <div className="books-header">
        <motion.h2
          className="books-title"
          variants={fadeIn("up", "spring", 0.1, 0.8)}
        >
          Explore Our Digital Library{" "}
        </motion.h2>

        <motion.h4
          className="books-subtitle"
          variants={fadeIn("up", "spring", 0.1, 1.3)}
        >
          Books, Magazines & E-Resources
        </motion.h4>

        <motion.p
          className="books-desc"
          variants={fadeIn("up", "spring", 0.1, 1.6)}
        >
          Dive into powerful ebooks and anointed digital magazines that will
          deepen your walk with God. Feed your spirit at your own pace
        </motion.p>
      </div>

      <motion.div
        className="books-scroll-container"
        variants={fadeIn("up", "spring", 0.1, 2.2)}
      >
        <HorizontalScroll
          showIndicator={false}
          showArrows={true}
          showArrowsOnDesktop={true}
          autoScroll
        >
          {books.map((book, idx) => (
            <BookCard
              key={idx}
              image={book.image}
              title={book.title}
              desc={book.desc}
              link={bookPaths[normalize(book.title)] ?? book.link}
            />
          ))}
        </HorizontalScroll>
      </motion.div>

      {/* Hidden for now along with the /dgr page (see App.tsx)
      <Button
        text="View our Digital Resources"
        onClick={() => (window.location.href = "/dgr")}
      /> */}
    </motion.section>
  );
}

export default Books;
